// ✅ scheduleUtils.js

// --- Shared Helpers ---
import moment from "moment/moment";

const getNextDayIndex = (currentId) => (currentId % 7) + 1;
const getPreviousDayIndex = (currentId) => ((currentId - 2 + 7) % 7) + 1;

// --- Variant A: uses classAvailability (first + second code) ---
export const isTimeConflictFromAvailability = (
    currentSchedule,
    currentDayIndex,
    classAvailability,
    calculateTimeDifferenceInMinutes,
    classDuration
) => {
    return classAvailability.some((day) => {
        let relativeDay;

        if (getNextDayIndex(currentDayIndex) === day.index) {
            relativeDay = "nextDay";
        } else if (getPreviousDayIndex(currentDayIndex) === day.index) {
            relativeDay = "previousDay";
        }

        if (relativeDay) {
            return day.schedules.some((schedule) => {
                const totalClassMinDiff = calculateTimeDifferenceInMinutes(
                    currentSchedule.time,
                    schedule.time,
                    relativeDay
                );
                return totalClassMinDiff < +classDuration;
            });
        }

        return false;
    });
};

// --- Variant B: uses day & selectedDay (third code) ---
export const isTimeConflictFromRelevantDays = (
    day,
    selectedDay,
    payload,
    calculateTimeDifferenceInMinutes,
    classDuration
) => {
    let relativeDay;

    if (getNextDayIndex(selectedDay) === day.index) {
        relativeDay = "nextDay";
    } else if (getPreviousDayIndex(selectedDay) === day.index) {
        relativeDay = "previousDay";
    }

    return day.schedules.some((schedule) => {
        const totalClassMinDiff = calculateTimeDifferenceInMinutes(
            payload.time,
            schedule.time,
            relativeDay
        );
        return totalClassMinDiff < +classDuration;
    });
};

const getMinutesDuration = (start, end) => {
    const date1 = moment(start, "h:mm A")
    const date2 = moment(end, "h:mm A")
    const duration = moment.duration(date2.diff(date1)).asMinutes()
    return duration
}

export const hasTimeConflict = (classAvailability, classDuration) => {
    for (const day of classAvailability) {
        const schedules = day.schedules;

        for (let i = 0; i < schedules.length; i++) {
            for (let j = i + 1; j < schedules.length; j++) {
                const totalClassMinDiff = getMinutesDuration(
                    schedules[i].time,
                    schedules[j].time
                );

                if (totalClassMinDiff < +classDuration) {
                    return true;
                }
            }
        }
    }

    return false;
};

